// extracted by mini-css-extract-plugin
module.exports = {"section":"what-residents-see_section__2Fwmx","wrapper":"what-residents-see_wrapper__i7Y0C","list":"what-residents-see_list__q2HSU"};